import { doc, getDoc, getDocFromServer } from "firebase/firestore";
import { db } from "../../firebase";
import { GetServiceOpts, EntityGet, EntityServerGet } from "../../types";
import { Externalautomation } from "./types";
import { transformMetadata, processTimestampFields } from "../../utils";

export type ExternalautomationGetService<T> = (
  agentId: string,
  id: string,
  opts?: GetServiceOpts
) => Promise<T | null>;

const get: ExternalautomationGetService<EntityGet<Externalautomation>> = async (
  agentId,
  id,
  opts = {}
) => {
  const docRef = doc(db, `/agent/${agentId}/externalautomation/${id}`);
  const { disableCache } = opts;
  const getFn = disableCache ? getDocFromServer : getDoc;
  const docSnap = await getFn(docRef);
  if (docSnap.exists()) {
    return processTimestampFields(
      transformMetadata({
        ...docSnap.data(),
        id: docSnap.id,
      } as EntityServerGet<Externalautomation>)
    ) as EntityGet<Externalautomation>;
  }
  return null;
};

export default get;
